<template>
	
		<!--头部-温馨提示-->
		<div class="home-head">
			<div class="weather-icon">
				<!--白天-->
				<div v-if="timeState!='night' && timeState!='lateNight'">
					<!--晴天-->
					<div
						v-if="IsInArray(weatherData.weather, ['晴','少云','晴间多云','多云','有风','平静','微风','和风','清风','强风/劲风','疾风','热','未知'])">
						<svg t="1682049897604" class="icon" viewBox="0 0 1024 1024" version="1.1"
							xmlns="http://www.w3.org/2000/svg" p-id="2157" width="32" height="32">
							<path
								d="M874.8544 542.72h-133.12a25.6 25.6 0 0 1-25.6-25.6v-10.24a25.6 25.6 0 0 1 25.6-25.6h133.12a25.6 25.6 0 0 1 25.6 25.6v10.24a25.6 25.6 0 0 1-25.6 25.6zM705.42336 367.2064a25.6 25.6 0 0 1-36.20864 0l-7.23968-7.23968a25.6 25.6 0 0 1 0-36.1984l94.12608-94.13632a25.6 25.6 0 0 1 36.20864 0l7.20896 7.23968a25.6 25.6 0 0 1 0 36.20864zM517.91872 317.44h-10.24a25.6 25.6 0 0 1-25.6-25.6v-133.12a25.6 25.6 0 0 1 25.6-25.6h10.24a25.6 25.6 0 0 1 25.6 25.6v133.12a25.6 25.6 0 0 1-25.6 25.6z m-162.19136 49.7664a25.74336 25.74336 0 0 1-36.33152 0l-94.464-94.12608a25.6 25.6 0 0 1 0-36.20864l7.2704-7.23968a25.76384 25.76384 0 0 1 36.33152 0l94.45376 94.13632a25.52832 25.52832 0 0 1 0 36.1984z m-47.104 139.6736v10.24A25.6 25.6 0 0 1 282.9312 542.72H149.37088a25.6 25.6 0 0 1-25.69216-25.6v-10.24a25.6 25.6 0 0 1 25.69216-25.6h133.5808a25.6 25.6 0 0 1 25.69216 25.6z m10.752 149.9136a25.74336 25.74336 0 0 1 36.33152 0l7.2704 7.23968a25.52832 25.52832 0 0 1 0 36.1984l-94.45376 94.13632a25.76384 25.76384 0 0 1-36.33152 0l-7.2704-7.24992a25.52832 25.52832 0 0 1 0-36.1984zM507.67872 706.56h10.45504a25.6 25.6 0 0 1 25.6 25.6v133.12a25.6 25.6 0 0 1-25.6 25.6h-10.45504a25.6 25.6 0 0 1-25.6-25.6v-133.12a25.6 25.6 0 0 1 25.6-25.6z m162.19136-49.7664a25.74336 25.74336 0 0 1 36.33152 0l94.464 94.12608a25.6 25.6 0 0 1 0 36.1984l-7.2704 7.24992a25.76384 25.76384 0 0 1-36.33152 0l-94.464-94.13632a25.52832 25.52832 0 0 1 0-36.1984z"
								fill="#FFCD00" p-id="2158"></path>
							<path
								d="M517.91872 517.12m-158.72 0a158.72 158.72 0 1 0 317.44 0 158.72 158.72 0 1 0-317.44 0Z"
								fill="#FFCD00" p-id="2159"></path>
						</svg>
					</div>
					<!--阴天-->
					<div v-if="IsInArray(weatherData.weather, ['阴'])">
						<svg t="1682052042250" class="icon" viewBox="0 0 1024 1024" version="1.1"
							xmlns="http://www.w3.org/2000/svg" p-id="3804" width="32" height="32">
							<path
								d="M526.04928 391.43424a20.13184 20.13184 0 0 1-28.672 0l-5.72416-5.76512a20.5312 20.5312 0 0 1 0-28.86656l74.45504-75.04896a20.13184 20.13184 0 0 1 28.672 0l5.72416 5.76512a20.5312 20.5312 0 0 1 0 28.86656z m-97.04448 209.38752a181.16608 181.16608 0 0 0-65.9968 35.7376 126.45376 126.45376 0 1 1 133.77536-165.5808 239.47264 239.47264 0 0 0-67.77856 129.8432z m-50.176-249.06752h-10.24a19.16928 19.16928 0 0 1-19.16928-19.17952V223.97952A19.16928 19.16928 0 0 1 368.56832 204.8h10.24a19.16928 19.16928 0 0 1 19.17952 19.17952v108.5952a19.16928 19.16928 0 0 1-19.17952 19.17952z m-129.35168 39.68a20.25472 20.25472 0 0 1-28.74368 0l-74.752-75.04896a20.48 20.48 0 0 1 0-28.86656l5.75488-5.76512a20.24448 20.24448 0 0 1 28.73344 0l74.752 75.04896a20.48 20.48 0 0 1 0 28.86656zM212.21376 502.784v8.192a20.36736 20.36736 0 0 1-20.31616 20.40832H86.23104A20.36736 20.36736 0 0 1 65.91488 510.976v-8.192a20.35712 20.35712 0 0 1 20.31616-20.40832h105.63584a20.35712 20.35712 0 0 1 20.34688 20.40832z m8.4992 119.52128a20.2752 20.2752 0 0 1 28.74368 0l5.74464 5.77536a20.48 20.48 0 0 1 0 28.86656l-74.752 75.04896a20.24448 20.24448 0 0 1-28.73344 0l-5.75488-5.77536a20.48 20.48 0 0 1 0-28.86656z"
								fill="#FFCD00" p-id="3805"></path>
							<path
								d="M250.23488 819.2h645.12s153.6-110.08-20.48-204.8c0 0-14.08-184.32-194.56-184.32 0 0-186.88-26.88-204.8 194.56 0 0-139.48928-11.776-143.36 122.88-92.5696 0.512-105.59488 71.68-81.92 71.68z"
								fill="#CCDCF5" p-id="3806"></path>
						</svg>
					</div>
					<!--雨天-->
					<div v-if="weatherData.weather.includes('雨')">
						<svg t="1682051139100" class="icon" viewBox="0 0 1024 1024" version="1.1"
							xmlns="http://www.w3.org/2000/svg" p-id="2587" width="32" height="32">
							<path
								d="M867.9424 559.04256H88.7808c-28.2624-0.1536 11.776-136.26368 114.688-92.16-3.8912-145.28512 157.3888-123.35104 157.3888-123.35104 21.6064-245.28896 247.296-215.51104 247.296-215.51104 218.0096 0 235.008 204.16512 235.008 204.16512 210.2272 104.91904 24.7808 226.85696 24.7808 226.85696z"
								fill="#CCDCF5" p-id="2588"></path>
							<path
								d="M295.6288 852.46976a46.08 46.08 0 0 1-92.16 0c0-24.576 46.08-98.8672 46.08-98.8672s46.08 74.30144 46.08 98.8672z m40.96-252.4672s40.96 63.68256 40.96 84.74624a41.0624 41.0624 0 0 1-81.92 0c0-21.06368 40.96-84.74624 40.96-84.74624z m174.08 252.4672a46.08 46.08 0 0 1-92.16 0c0-24.576 46.08-98.8672 46.08-98.8672s46.08 74.30144 46.08 98.8672z m40.96-252.4672s40.96 63.68256 40.96 84.74624a41.0624 41.0624 0 0 1-81.92 0c0-21.06368 40.96-84.74624 40.96-84.74624z m143.36 252.4672a46.08 46.08 0 0 1-92.16 0c0-24.576 46.08-98.8672 46.08-98.8672s46.08 74.30144 46.08 98.8672z m40.96-252.4672s40.96 63.68256 40.96 84.74624a41.0624 41.0624 0 0 1-81.92 0c0-21.06368 40.96-84.74624 40.96-84.74624z"
								fill="#FFCD00" p-id="2589"></path>
						</svg>
					</div>
					<!--雪-->
					<div v-if="IsInArray(weatherData.weather, ['雪','阵雪','小雪','中雪','大雪','暴雪','小雪-中雪','中雪-大雪','大雪-暴雪'])">
						<svg t="1682051430103" class="icon" viewBox="0 0 1024 1024" version="1.1"
							xmlns="http://www.w3.org/2000/svg" p-id="2802" width="32" height="32">
							<path
								d="M88.97536 569.57952h779.1616s185.51808-121.93792-24.73984-226.85696c0 0-16.9984-204.17536-234.97728-204.17536 0 0-225.71008-29.76768-247.35744 215.51104 0 0-161.2288-21.92384-157.32736 123.36128-102.98368-44.11392-143.0016 92.0064-114.75968 92.16z"
								fill="#CCDCF5" p-id="2803"></path>
							<path
								d="M734.52544 726.24128a22.016 22.016 0 0 1-19.968 1.16736l-41.984 24.68864a41.22624 41.22624 0 0 1 1.69984 11.48928c0 1.08544-0.16384 2.12992-0.24576 3.19488l40.57088 23.83872a22.016 22.016 0 0 1 19.968 1.16736 22.8352 22.8352 0 0 1 11.14112 19.85536 9.13408 9.13408 0 0 1-0.67584 7.41376l-4.48512 7.91552a8.88832 8.88832 0 0 1-5.98016 4.3008 22.0672 22.0672 0 0 1-22.46656 0.11264 22.80448 22.80448 0 0 1-10.97728-17.00864l-38.16448-22.4256a40.73472 40.73472 0 0 1-15.63648 10.24v43.76576a22.87616 22.87616 0 0 1-2.33472 37.888 8.79616 8.79616 0 0 1-6.64576 3.072h-9.02144a8.8064 8.8064 0 0 1-6.64576-3.072 22.87616 22.87616 0 0 1-2.33472-37.888v-43.74528a40.76544 40.76544 0 0 1-15.63648-10.24l-38.16448 22.4256a22.784 22.784 0 0 1-10.98752 17.00864 22.05696 22.05696 0 0 1-22.46656-0.11264 8.86784 8.86784 0 0 1-5.98016-4.3008l-4.49536-7.91552a9.15456 9.15456 0 0 1-0.6656-7.41376 22.8352 22.8352 0 0 1 11.14112-19.85536 22.016 22.016 0 0 1 19.968-1.16736l40.57088-23.83872c-0.08192-1.024-0.256-2.10944-0.256-3.19488a41.22624 41.22624 0 0 1 1.69984-11.48928l-41.984-24.68864a22.016 22.016 0 0 1-19.968-1.16736 22.8352 22.8352 0 0 1-11.14112-19.85536 9.15456 9.15456 0 0 1 0.6656-7.41376l4.49536-7.91552a8.86784 8.86784 0 0 1 5.98016-4.3008 22.03648 22.03648 0 0 1 22.46656-0.1024 22.75328 22.75328 0 0 1 10.98752 17.00864l44.56448 26.17344a40.448 40.448 0 0 1 9.216-4.87424v-52.91008a22.87616 22.87616 0 0 1 2.33472-37.888 8.79616 8.79616 0 0 1 6.64576-3.072h8.93952a8.78592 8.78592 0 0 1 6.64576 3.072 22.87616 22.87616 0 0 1 2.33472 37.888v52.91008a40.42752 40.42752 0 0 1 9.216 4.87424l44.56448-26.17344a22.77376 22.77376 0 0 1 10.97728-17.00864 22.04672 22.04672 0 0 1 22.46656 0.1024 8.88832 8.88832 0 0 1 5.98016 4.3008l4.48512 7.91552a9.13408 9.13408 0 0 1 0.67584 7.41376 22.8352 22.8352 0 0 1-11.08992 19.83488z"
								fill="#FFCD00" p-id="2804"></path>
							<path
								d="M430.1824 683.73504a10.35264 10.35264 0 0 1-9.10336 0.512l-19.1488 10.86464a17.53088 17.53088 0 0 1 0.768 5.05856c0 0.47104-0.07168 0.93184-0.11264 1.40288l18.49344 10.48576a10.32192 10.32192 0 0 1 9.10336 0.52224 9.97376 9.97376 0 0 1 5.12 8.72448 3.91168 3.91168 0 0 1-0.3072 3.26656l-2.048 3.4816a4.096 4.096 0 0 1-2.72384 1.8944 10.36288 10.36288 0 0 1-10.24 0 9.99424 9.99424 0 0 1-5.00736-7.48544l-17.408-9.87136a18.5344 18.5344 0 0 1-7.168 4.51584v19.26144a9.87136 9.87136 0 0 1-1.024 16.68096 4.096 4.096 0 0 1-3.072 1.37216h-4.03456a4.096 4.096 0 0 1-3.072-1.37216 9.87136 9.87136 0 0 1-1.024-16.68096V717.1072a18.54464 18.54464 0 0 1-7.168-4.51584l-17.408 9.87136a10.00448 10.00448 0 0 1-5.00736 7.48544 10.36288 10.36288 0 0 1-10.24 0 4.096 4.096 0 0 1-2.72384-1.8944l-2.048-3.4816a3.91168 3.91168 0 0 1-0.3072-3.26656 9.97376 9.97376 0 0 1 5.12-8.72448 10.32192 10.32192 0 0 1 9.10336-0.52224l18.49344-10.48576c0-0.47104-0.11264-0.93184-0.11264-1.40288a17.53088 17.53088 0 0 1 0.768-5.05856l-19.1488-10.86464a10.35264 10.35264 0 0 1-9.10336-0.512 9.97376 9.97376 0 0 1-5.12-8.73472 3.91168 3.91168 0 0 1 0.3072-3.26656l2.048-3.4816a4.096 4.096 0 0 1 2.72384-1.8944 10.36288 10.36288 0 0 1 10.24 0 9.984 9.984 0 0 1 5.00736 7.48544l20.31616 11.50976a18.90304 18.90304 0 0 1 4.20864-2.14016v-23.33696a9.8816 9.8816 0 0 1 1.024-16.6912 4.096 4.096 0 0 1 3.072-1.37216h4.096a4.096 4.096 0 0 1 3.072 1.37216 9.8816 9.8816 0 0 1 1.024 16.6912v23.27552a18.91328 18.91328 0 0 1 4.20864 2.14016l20.31616-11.50976a9.984 9.984 0 0 1 5.00736-7.48544 10.36288 10.36288 0 0 1 10.24 0 4.096 4.096 0 0 1 2.72384 1.8944l2.048 3.4816a3.91168 3.91168 0 0 1 0.3072 3.26656 9.97376 9.97376 0 0 1-5.07904 8.79616z"
								fill="#FFCD00" p-id="2805"></path>
						</svg>
					</div>
					<!--雾-->
					<div v-if="IsInArray(weatherData.weather, ['雾','浓雾','强浓雾','轻雾','大雾','特强浓雾'])">
						<svg t="1682051508112" class="icon" viewBox="0 0 1024 1024" version="1.1"
							xmlns="http://www.w3.org/2000/svg" p-id="2946" width="32" height="32">
							<path
								d="M829.2352 809.12384h-634.88a30.72 30.72 0 0 1-30.72-30.72v-51.2a30.72 30.72 0 0 1 30.72-30.72h634.88a30.72 30.72 0 0 1 30.72 30.72v51.2a30.72 30.72 0 0 1-30.72 30.72z m0-245.76h-634.88a30.72 30.72 0 0 1-30.72-30.72v-51.2a30.72 30.72 0 0 1 30.72-30.72h634.88a30.72 30.72 0 0 1 30.72 30.72v51.2a30.72 30.72 0 0 1-30.72 30.72z m0-235.52h-634.88a30.72 30.72 0 0 1-30.72-30.72v-51.2a30.72 30.72 0 0 1 30.72-30.72h634.88a30.72 30.72 0 0 1 30.72 30.72v51.2a30.72 30.72 0 0 1-30.72 30.72z"
								fill="#FFCD00" p-id="2947"></path>
							<path
								d="M829.2352 563.36384h-634.88a30.72 30.72 0 0 1-30.72-30.72v-51.2a30.72 30.72 0 0 1 30.72-30.72h634.88a30.72 30.72 0 0 1 30.72 30.72v51.2a30.72 30.72 0 0 1-30.72 30.72z"
								fill="#CCDCF5" p-id="2948"></path>
						</svg>
					</div>
					<!--霾-->
					<div v-if="IsInArray(weatherData.weather, ['霾','中度霾','重度霾','严重霾'])">
						<svg t="1682051600498" class="icon" viewBox="0 0 1024 1024" version="1.1"
							xmlns="http://www.w3.org/2000/svg" p-id="3089" width="32" height="32">
							<path
								d="M765.3376 727.04c-87.3472-1.20832-210.1248-14.7456-262.7584-112.09728-41.5744 104.20224-163.84 122.6752-233.984 122.33728C166.7072 736.79872 7.7824 691.2 10.24 522.24c2.8672-197.09952 171.4176-214.17984 228.5568-215.04 64.8192-1.024 193.4336 28.04736 250.1632 121.6C533.0944 305.77664 687.5136 296.47872 735.5392 296.96 862.208 298.24 1013.76 396.8 1013.76 522.24S884.6336 728.68864 765.3376 727.04zM228.864 419.84c-124.2112 2.56-159.0272 81.92-159.0272 81.92v30.72c0 43.59168 95.8464 82.03264 172.8512 81.92 72.704-0.14336 174.3872-87.93088 174.8992-133.12 0.2048-17.18272-89.3952-63.488-188.7232-61.44z m685.568 61.44s-44.7488-58.88-168.96-61.44c-99.328-2.048-169.0624 105.69728-168.8576 122.88 0.4096 45.1584 116.1216 71.53664 188.7232 71.68 77.1072 0.1536 158.9248-47.4624 159.0272-92.16a69.632 69.632 0 0 0-9.9328-40.96z"
								fill="#FFCC00" p-id="3090"></path>
							<path
								d="M762.2656 256a51.2 51.2 0 1 1 51.2-51.2 51.2 51.2 0 0 1-51.2 51.2z m-235.52 20.48a51.2 51.2 0 1 1 51.2-51.2 51.2 51.2 0 0 1-51.2 51.2z m-266.24-20.48a51.2 51.2 0 1 1 51.2-51.2 51.2 51.2 0 0 1-51.2 51.2z m30.72 512a51.2 51.2 0 1 1-51.2 51.2 51.2 51.2 0 0 1 51.2-51.2z m235.52-20.48a51.2 51.2 0 1 1-51.2 51.2 51.2 51.2 0 0 1 51.2-51.2z m235.52 20.48a51.2 51.2 0 1 1-51.2 51.2 51.2 51.2 0 0 1 51.2-51.2z"
								fill="#CCDCF5" p-id="3091"></path>
						</svg>
					</div>
					<!--沙尘暴-->
					<div v-if="IsInArray(weatherData.weather, ['浮尘','扬沙','沙尘暴','强沙尘暴'])">
						<svg t="1682052010403" class="icon" viewBox="0 0 1024 1024" version="1.1"
							xmlns="http://www.w3.org/2000/svg" p-id="3661" width="32" height="32">
							<path
								d="M957.0816 667.4944s24.3712 12.8-348.16-61.44-428.7488-234.24-440.32-327.68 166.4-203.52 296.96-112.64 81.92 238.08-51.2 256-124.1088-102.4-102.4-143.36 89.6-60.16 112.64 10.24-40.96 57.6-40.96 30.72-30.72 0-30.72 0c-40.96 48.64 61.44 51.2 61.44 51.2 130.56-55.04 30.72-175.36-71.68-184.32s-149.7088 112.64-81.92 194.56c137.0112 162.56 256 133.12 256 133.12-17.92-115.2 47.4112-215.04 153.6-184.32 212.48 51.2 120.32 194.56 30.72 215.04s-130.56-92.16-71.68-122.88 124.2112 47.36 51.2 40.96-12.8 47.36 20.48 30.72c96.0512-47.36 3.8912-117.76-71.68-112.64s-92.16 131.84-20.48 174.08 272.6912 21.76 327.68 40.96 20.48 71.68 20.48 71.68z m-358.4-30.72c168.96 13.64992 337.92 92.16 337.92 92.16 37.5808 52.91008-20.48 40.96-20.48 40.96s-304.64-113.92-450.56-92.16c-142.1312 21.1968-109.6704 132.98688-61.44 153.6 39.8336 16.9984 137.0112 1.28 122.88-51.2-101.0688-110.08-19.8656 15.77984-66.7648 24.10496-79.0528 14.00832-68.096-105.32864 10.4448-104.99072 79.36 0.33792 153.8048 98.304 35.84 173.056s-194.56-81.92-194.56-81.92c-15.36-153.61024 117.76-167.22944 286.72-153.61024z"
								fill="#F5CD0A" p-id="3662"></path>
							<path
								d="M199.3216 452.4544a30.72 30.72 0 1 1-30.72-30.72 30.72 30.72 0 0 1 30.72 30.72z m-87.04 163.84a35.84 35.84 0 1 1 35.84-35.84 35.84 35.84 0 0 1-35.84 35.84z m-20.48-276.48a35.84 35.84 0 1 1 35.84-35.84 35.84 35.84 0 0 1-35.84 35.84z m92.16 317.44a35.84 35.84 0 1 1-35.84 35.84 35.84 35.84 0 0 1 35.84-35.84z m92.16-143.36a35.84 35.84 0 1 1-35.84 35.84 35.84 35.84 0 0 1 35.84-35.84z m5.12 112.64a30.72 30.72 0 1 1-30.72 30.72 30.72 30.72 0 0 1 30.72-30.72z"
								fill="#FFFFFF" p-id="3663"></path>
						</svg>
					</div>
					<!--龙卷风-->
					<div v-if="IsInArray(weatherData.weather, ['龙卷风','大风','烈风','风暴','狂爆风','飓风','热带风暴'])">
						<svg t="1682052000224" class="icon" viewBox="0 0 1024 1024" version="1.1"
							xmlns="http://www.w3.org/2000/svg" p-id="3518" width="32" height="32">
							<path
								d="M935.168 542.72c-44.3392 78.336-139.84768 48.56832-61.44 133.12 60.4672 65.19808-59.392 235.52-389.12 235.52h-81.92s47.104-8.192 174.08-51.2 307.2-188.416 71.68-153.6-307.2 51.2-327.68 20.48 26.624-16.384 92.16-20.48 317.44-51.2 337.92-133.12 10.24-94.208-71.68-71.68-110.592 69.632-266.24 81.92-522.24 22.528-215.04-20.48 489.472-124.928 512-194.56 6.144-131.072-163.84-143.36c0 0 200.704-145.408 368.64 10.24 49.152 77.824-12.288 147.456-40.96 174.08s109.34272 48.57856 61.44 133.12z"
								fill="#FFCC00" p-id="3519"></path>
							<path
								d="M464.128 829.44a30.72 30.72 0 1 1-30.72-30.72 30.72 30.72 0 0 1 30.72 30.72z m40.96-189.44a25.6 25.6 0 1 1-25.6-25.6 25.6 25.6 0 0 1 25.6 25.6z m-25.6-271.36a35.84 35.84 0 1 1 35.84-35.84A35.84 35.84 0 0 1 479.5392 368.64z m0-184.32a35.84 35.84 0 1 1 35.84-35.84A35.84 35.84 0 0 1 479.5392 184.32z m-163.84 286.72a35.84 35.84 0 1 1 35.84-35.84 35.84 35.84 0 0 1-35.84 35.84z m-10.24-286.72a35.84 35.84 0 1 1 35.84-35.84A35.84 35.84 0 0 1 305.4592 184.32z m-122.88 184.32a35.84 35.84 0 1 1 35.84-35.84 35.84 35.84 0 0 1-35.84 35.84z m56.32 296.96a30.72 30.72 0 1 1-30.72 30.72 30.72 30.72 0 0 1 30.72-30.72z"
								fill="#CCDCF5" p-id="3520"></path>
						</svg>
					</div>
				</div>
				<!--夜晚-->
				<div v-else>
					<svg t="1682052093607" class="icon" viewBox="0 0 1024 1024" version="1.1"
						xmlns="http://www.w3.org/2000/svg" p-id="3947" width="32" height="32">
						<path
							d="M483.69664 870.4a368.64 368.64 0 0 1-332.58496-209.408A310.60992 310.60992 0 0 0 273.77664 686.08c166.83008 0 302.08-130.6624 302.08-291.84a290.38592 290.38592 0 0 0-156.0576-255.46752A368.64 368.64 0 1 1 483.69664 870.4z"
							fill="#FFFFFF" p-id="3948"></path>
						<path
							d="M504.17664 890.88a368.64 368.64 0 0 1-332.58496-209.408A310.6304 310.6304 0 0 0 294.25664 706.56c166.83008 0 302.08-130.6624 302.08-291.84a290.38592 290.38592 0 0 0-156.0576-255.46752A368.64 368.64 0 1 1 504.17664 890.88z"
							fill="#FFCC00" p-id="3949"></path>
					</svg>
				</div>
			</div>
			<div class="weatherText" style="display: flex;align-items: center;">
				<div>{{weatherData.weather}}</div>
				<span>&nbsp;</span>
				<div>{{weatherData.temperature_float}}°</div>
			</div>
			<div style="left: 2%;position: relative;">
				<div v-if="timeState == 'daybreak' || timeState == 'morning'">清晨太阳升起，明亮你的心情；传达一声问候，温暖你的心情</div>
				<div v-if="timeState == 'noon' || timeState == 'afternoon'">阳光在蔓延，未来在当下。</div>
				<div v-if="timeState == 'night'">微风吹，星光照，愿你今夜安然入睡，美梦甜甜。</div>
				<div v-if="timeState == 'lateNight'">夜已深，道一声晚安；盖好被，防感冒；安然入睡，好梦连连！</div>
			</div>
			<div style="position: absolute;right: 4%;color: #d9d9d9 ;">客户版</div>
		</div>
		<!-- 中间区 -->
		<div style="display: flex;align-items: flex-start;justify-content: right;">
			<div class="middle-left">
				<div class="popular-nav">
					<div class="popular-nav-title">常用功能</div>
					<div class="item-list">
						<div class="item" @click="$commonFunction.to('/express/createOrder')">
							<div class="item-icon" style="background-color: #d8ecff;">
								<svg t="1681959546451" class="icon" viewBox="0 0 1024 1024" version="1.1"
									xmlns="http://www.w3.org/2000/svg" p-id="3760" width="32" height="32">
									<path
										d="M809.3696 302.0288H215.552V204.6464c0-73.5232 59.5968-133.12 133.12-133.12h327.5776c73.5232 0 133.12 59.5968 133.12 133.12v97.3824z"
										fill="#95C9FC" p-id="3761"></path>
									<path
										d="M864.1536 717.3632H160.768c-50.8928 0-92.16-41.2672-92.16-92.16V430.0288c0-73.5232 59.5968-133.12 133.12-133.12h621.4656c73.5232 0 133.12 59.5968 133.12 133.12v195.1744c0 50.8928-41.2672 92.16-92.16 92.16z"
										fill="#80B7F9" p-id="3762"></path>
									<path
										d="M726.9376 949.0432H297.9328c-45.2608 0-81.92-36.6592-81.92-81.92v-211.3536c0-45.2608 36.6592-81.92 81.92-81.92h429.0048c45.2608 0 81.92 36.6592 81.92 81.92v211.3536c0 45.2608-36.6592 81.92-81.92 81.92z"
										fill="#80B7F9" p-id="3763"></path>
									<path
										d="M808.8576 717.3632v-61.5936c0-45.2608-36.6592-81.92-81.92-81.92H297.9328c-45.2608 0-81.92 36.6592-81.92 81.92v61.5936h592.8448z"
										fill="#3E8BF8" p-id="3764"></path>
									<path
										d="M797.7984 464.2304h-102.1952c-22.6304 0-40.96-18.3296-40.96-40.96s18.3296-40.96 40.96-40.96h102.1952c22.6304 0 40.96 18.3296 40.96 40.96s-18.3296 40.96-40.96 40.96zM604.9792 831.0272h-271.36c-22.6304 0-40.96-18.3296-40.96-40.96s18.3296-40.96 40.96-40.96h271.4112c22.6304 0 40.96 18.3296 40.96 40.96s-18.3808 40.96-41.0112 40.96z"
										fill="#FFFFFF" p-id="3765"></path>
								</svg>
							</div>
							<p class="item-title">录入打单</p>
						</div>
						<div class="item" @click="$commonFunction.to('/workbench/workOrder')">
							<div class="item-icon" style="background-color: #ffeacf;">
								<svg t="1681962856749" class="icon" viewBox="0 0 1024 1024" version="1.1"
									xmlns="http://www.w3.org/2000/svg" p-id="5698" width="32" height="32">
									<path
										d="M704.2048 935.8848H246.7328c-73.5232 0-133.12-59.5968-133.12-133.12V217.4976c0-73.5232 59.5968-133.12 133.12-133.12h457.472c73.5232 0 133.12 59.5968 133.12 133.12v585.2672c0 73.5232-59.5968 133.12-133.12 133.12z"
										fill="#FFAC3E" p-id="5699"></path>
									<path
										d="M639.4368 326.0416H314.368c-22.6304 0-40.96-18.3296-40.96-40.96s18.3296-40.96 40.96-40.96h325.12c22.6304 0 40.96 18.3296 40.96 40.96s-18.3808 40.96-41.0112 40.96zM639.4368 488.448H314.368c-22.6304 0-40.96-18.3296-40.96-40.96s18.3296-40.96 40.96-40.96h325.12c22.6304 0 40.96 18.3296 40.96 40.96s-18.3808 40.96-41.0112 40.96zM470.016 650.8544H314.368c-22.6304 0-40.96-18.3296-40.96-40.96s18.3296-40.96 40.96-40.96h155.648c22.6304 0 40.96 18.3296 40.96 40.96s-18.3296 40.96-40.96 40.96z"
										fill="#FFFFFF" p-id="5700"></path>
									<path
										d="M750.2336 743.1168m-189.952 0a189.952 189.952 0 1 0 379.904 0 189.952 189.952 0 1 0-379.904 0Z"
										fill="#FFAC3E" p-id="5701"></path>
									<path
										d="M750.2336 552.8064c-104.9088 0-189.952 85.0432-189.952 189.952 0 99.9936 77.2608 181.8624 175.36 189.3376 58.368-14.08 101.7856-66.6624 101.7856-129.3824V573.952a190.21312 190.21312 0 0 0-87.1936-21.1456z"
										fill="#FF7C0E" p-id="5702"></path>
									<path
										d="M645.7856 743.1168m-35.9936 0a35.9936 35.9936 0 1 0 71.9872 0 35.9936 35.9936 0 1 0-71.9872 0Z"
										fill="#FFFFFF" p-id="5703"></path>
									<path
										d="M750.6432 743.1168m-35.9936 0a35.9936 35.9936 0 1 0 71.9872 0 35.9936 35.9936 0 1 0-71.9872 0Z"
										fill="#FFFFFF" p-id="5704"></path>
									<path
										d="M855.5008 743.1168m-35.9936 0a35.9936 35.9936 0 1 0 71.9872 0 35.9936 35.9936 0 1 0-71.9872 0Z"
										fill="#FFFFFF" p-id="5705"></path>
								</svg>
							</div>
							<p class="item-title">快递工单</p>
						</div>
						<div class="item" @click="$commonFunction.to('/query/stop')">
							<div class="item-icon" style="background-color: #d8dbfb;">
								<svg t="1681962297771" class="icon" viewBox="0 0 1024 1024" version="1.1"
									xmlns="http://www.w3.org/2000/svg" p-id="4757" width="32" height="32">
									<path
										d="M84.3776 798.1056a431.9744 144.1792 0 1 0 863.9488 0 431.9744 144.1792 0 1 0-863.9488 0Z"
										fill="#A5ADF6" p-id="4758"></path>
									<path
										d="M826.2144 392.1408c0-171.1104-138.7008-309.8624-309.8624-309.8624s-309.8624 138.752-309.8624 309.8624c0 152.1152 164.4032 316.5696 275.968 414.5664 22.272 19.5584 55.552 19.6096 77.7728 0.0512 129.6896-114.1248 265.984-259.1744 265.984-414.6176z"
										fill="#A5ADF6" p-id="4759"></path>
									<path
										d="M516.352 653.9264c-62.5152 0-121.9072 4.4544-175.5648 12.4416 46.6944 53.76 98.2016 102.0928 141.7216 140.288 22.272 19.5584 55.552 19.6096 77.7728 0.0512 48.2304-42.4448 97.3312-89.1392 140.032-139.0592-55.808-8.7552-118.1696-13.7216-183.9616-13.7216z"
										fill="#635DF7" p-id="4760"></path>
									<path
										d="M516.352 549.5808c-86.1696 0-156.3136-70.0928-156.3136-156.3136s70.0928-156.3136 156.3136-156.3136 156.3136 70.144 156.3136 156.3136-70.144 156.3136-156.3136 156.3136z m0-230.7072c-41.0112 0-74.3936 33.3824-74.3936 74.3936s33.3824 74.3936 74.3936 74.3936 74.3936-33.3824 74.3936-74.3936-33.3824-74.3936-74.3936-74.3936z"
										fill="#FFFFFF" p-id="4761"></path>
								</svg>
							</div>
							<p class="item-title">停发查询</p>
						</div>
						<div class="item" @click="$commonFunction.to('/workbench/task')">
							<div class="item-icon" style="background-color: #d2f8ea;">
								<svg t="1681962671748" class="icon" viewBox="0 0 1024 1024" version="1.1"
									xmlns="http://www.w3.org/2000/svg" p-id="5269" width="32" height="32">
									<path
										d="M690.8928 941.824H233.4208c-73.5232 0-133.12-59.5968-133.12-133.12V223.4368c0-73.5232 59.5968-133.12 133.12-133.12h457.472c73.5232 0 133.12 59.5968 133.12 133.12v585.2672c0 73.5232-59.5968 133.12-133.12 133.12z"
										fill="#4BE2AC" p-id="5270"></path>
									<path
										d="M626.1248 332.032h-325.12c-22.6304 0-40.96-18.3296-40.96-40.96s18.3296-40.96 40.96-40.96h325.12c22.6304 0 40.96 18.3296 40.96 40.96s-18.3296 40.96-40.96 40.96zM626.1248 494.3872h-325.12c-22.6304 0-40.96-18.3296-40.96-40.96s18.3296-40.96 40.96-40.96h325.12c22.6304 0 40.96 18.3296 40.96 40.96s-18.3296 40.96-40.96 40.96zM456.704 656.7936H301.0048c-22.6304 0-40.96-18.3296-40.96-40.96s18.3296-40.96 40.96-40.96H456.704c22.6304 0 40.96 18.3296 40.96 40.96s-18.3296 40.96-40.96 40.96z"
										fill="#FFFFFF" p-id="5271"></path>
									<path
										d="M736.6144 748.4416m-189.952 0a189.952 189.952 0 1 0 379.904 0 189.952 189.952 0 1 0-379.904 0Z"
										fill="#4BE2AC" p-id="5272"></path>
									<path
										d="M736.8704 558.7456c-104.9088 0-189.952 85.0432-189.952 189.952 0 99.9936 77.2608 181.8624 175.36 189.3376 58.368-14.08 101.7856-66.6624 101.7856-129.3824v-228.8128a190.50496 190.50496 0 0 0-87.1936-21.0944z"
										fill="#06CC76" p-id="5273"></path>
									<path
										d="M820.4288 826.0096h-104.96c-22.6304 0-40.96-18.3296-40.96-40.96v-93.2864c0-22.6304 18.3296-40.96 40.96-40.96s40.96 18.3296 40.96 40.96v52.3264h64c22.6304 0 40.96 18.3296 40.96 40.96s-18.3296 40.96-40.96 40.96z"
										fill="#FFFFFF" p-id="5274"></path>
								</svg>
							</div>
							<p class="item-title">任务</p>
						</div>
						<div class="item" @click="$commonFunction.to('')">
							<div class="item-icon" style="background-color: #deecfd;">
								<svg t="1681963321879" class="icon" viewBox="0 0 1024 1024" version="1.1"
									xmlns="http://www.w3.org/2000/svg" p-id="6323" width="32" height="32">
									<path
										d="M775.168 790.1696c-9.3696-124.416-83.2512-231.1168-187.5968-287.3856 39.6288-41.728 64-98.0992 64-160.2048 0-128.512-104.192-232.704-232.704-232.704S186.1632 214.0672 186.1632 342.5792c0 62.0544 24.32 118.3744 63.8976 160.0512-112.1792 60.2624-188.5184 178.6368-188.5184 314.88 0 20.6336 1.7408 40.8064 5.12 60.4672a32.9728 32.9728 0 0 0 32.512 27.3408h639.3344c15.9744 0 29.7984-11.4688 32.512-27.1872 4.9152-28.3136 6.4512-57.7536 4.1472-87.9616z"
										fill="#80B7F9" p-id="6324"></path>
									<path
										d="M963.6864 734.72c-7.5776-100.4032-67.1744-186.5216-151.3984-231.936 32-33.6896 51.6608-79.1552 51.6608-129.28 0-103.7312-84.0704-187.8016-187.8016-187.8016S488.3968 269.824 488.3968 373.504c0 50.0736 19.6096 95.5392 51.5584 129.1776-90.5216 48.64-152.1664 144.128-152.1664 254.1056 0 16.64 1.4336 32.9216 4.1472 48.7936 2.2016 12.7488 13.312 22.0672 26.2656 22.0672h515.9424c12.9024 0 24.064-9.216 26.2144-21.9648 3.9424-22.8352 5.1712-46.592 3.328-70.9632z"
										fill="#80B7F9" p-id="6325"></path>
									<path
										d="M775.168 790.1696c-9.3696-124.416-83.2512-231.1168-187.5968-287.3856 39.6288-41.728 64-98.0992 64-160.2048 0-53.5552-18.1248-102.8096-48.4864-142.1312-67.4304 28.5184-114.688 95.232-114.688 173.056 0 50.0736 19.6096 95.5392 51.5584 129.1776-90.5216 48.64-152.1664 144.128-152.1664 254.1056 0 16.64 1.4336 32.9216 4.1472 48.7936 2.2016 12.7488 13.312 22.0672 26.2656 22.0672h357.8368c0.3584-12.3392 0.1024-24.832-0.8704-37.4784z"
										fill="#3E8BF8" p-id="6326"></path>
									<path
										d="M418.7136 817.408c-15.7184 0-30.5664-6.8608-40.7552-18.7904l-58.1632-68.1472a53.56544 53.56544 0 0 1-10.9056-49.1008l32.9216-119.1936c6.4-23.1424 27.648-39.3216 51.6608-39.3216h46.4896c23.7056 0 44.288 15.2064 51.2512 37.8368l36.7104 119.4496c5.4272 17.6128 1.4848 36.5056-10.4448 50.5344l-57.9584 67.8912c-10.24 11.9808-25.088 18.8416-40.8064 18.8416zM380.5184 691.2l38.1952 44.7488 37.7856-44.2368-29.8496-97.1776h-19.4048L380.5184 691.2z m82.432-7.0656l-0.0512 0.0512 0.0512-0.0512z"
										fill="#F7F8F8" p-id="6327"></path>
								</svg>
							</div>
							<p class="item-title">客户管理</p>
						</div>
						<div class="item" @click="$commonFunction.to('')">
							<div class="item-icon" style="background-color: #ffebba;">
								<svg t="1681963205654" class="icon" viewBox="0 0 1024 1024" version="1.1"
									xmlns="http://www.w3.org/2000/svg" p-id="5936" width="32" height="32">
									<path
										d="M235.6736 86.272h551.5264c17.408 0 33.3824 9.4208 41.8304 24.6272l102.9632 185.6a157.98272 157.98272 0 0 1 15.9744 80.2816c-5.0176 79.0016-69.5808 143.0528-148.6336 147.456-63.8976 3.584-120.1152-30.8736-148.1728-82.7904-26.7264 49.4592-79.0016 83.0464-139.1104 83.0464-60.5696 0-113.1008-34.048-139.6224-84.0704-27.8016 52.3776-84.1216 87.2448-148.2752 83.8656-79.5136-4.2496-144.384-68.7104-149.0432-148.1728-1.4336-24.4736 2.6624-47.8208 11.2128-68.9152l107.3664-195.9936a47.81056 47.81056 0 0 1 41.984-24.9344z"
										fill="#FFD05C" p-id="5937"></path>
									<path
										d="M877.9264 336.5376H145.152v476.0576c0 73.5232 59.5968 133.12 133.12 133.12h466.5344c73.5232 0 133.12-59.5968 133.12-133.12V336.5376z"
										fill="#FFD05C" p-id="5938"></path>
									<path
										d="M145.152 497.664c22.8864 15.4112 49.9712 25.0368 79.0016 26.5728 64.1536 3.4304 120.5248-31.488 148.2752-83.8144 26.5216 50.0224 79.104 84.0704 139.6224 84.0704 60.1088 0 112.384-33.5872 139.1104-83.0464 28.0064 51.9168 84.2752 86.3232 148.1728 82.7904 28.8768-1.5872 55.808-11.2128 78.592-26.5216V336.5376H145.152V497.664zM636.672 945.4592H386.4064v-204.8512c0-41.1648 33.3824-74.5472 74.5472-74.5472h101.1712c41.1648 0 74.5472 33.3824 74.5472 74.5472v204.8512z"
										fill="#FCA235" p-id="5939"></path>
								</svg>
							</div>
							<p class="item-title">云仓系统</p>
						</div>
					</div>
				</div>
				<!-- 轮播图 -->
				<div class="swiper">
					<el-carousel :interval="6000" height="19vh">
						<el-carousel-item v-for="(i,index) in bannerList" :key="index">
							<el-image style="width: 100%;height: 100%;" :src="i.url" fit="fill"></el-image>
						</el-carousel-item>
					</el-carousel>
				</div>
				<!--公告栏-->
				<div class="notice">
					<div class="notice-icon">
						<svg t="1681963978921" class="icon" viewBox="0 0 1024 1024" version="1.1"
							xmlns="http://www.w3.org/2000/svg" p-id="23857" width="16" height="16">
							<path
								d="M588.3 882c0 42.1-34.2 76.3-76.3 76.3s-76.3-34.2-76.3-76.3M512 203c-25.2 0-45.8-20.6-45.8-45.8v-45.8c0-25.2 20.6-45.8 45.8-45.8 25.2 0 45.8 20.6 45.8 45.8v45.8c0 25.2-20.6 45.8-45.8 45.8z"
								fill="#686868" p-id="23858"></path>
							<path
								d="M420.5 541.1c-18.2 0-32.9-14.7-32.9-32.9V370.9c0-18.2 14.7-32.9 32.9-32.9s32.9 14.7 32.9 32.9v137.3c-0.1 18.2-14.8 32.9-32.9 32.9z"
								fill="#2BA8FC" p-id="23859"></path>
							<path
								d="M792 853.9H232c-29.8 0-56.4-15.5-71.1-41.4-14.7-25.9-14.3-56.7 1-82.2l1.6-2.4 56.2-77.7V431.9c0-161.2 131.1-292.3 292.3-292.3 161.2 0 292.3 131.1 292.3 292.3v218.2l57.8 80.1c15.3 25.6 15.7 56.3 1 82.2-14.7 26-41.3 41.5-71.1 41.5zM217.8 765c-3.5 6.8-1 12.8 0.3 15.1 1.4 2.4 5.5 8.1 13.8 8.1H792c8.4 0 12.5-5.6 13.8-8.1 1.3-2.3 3.9-8.3 0.3-15.1l-56-77.3c-7.7-10.6-11.7-23.1-11.7-36.2V431.9c0-124.9-101.6-226.5-226.5-226.5S285.4 307 285.4 431.9v219.5c0 13-4 25.5-11.7 36.1L217.8 765z"
								fill="#686868" p-id="23860"></path>
						</svg>
					</div>
					<div class="notice-conten">
						<span class="notice-conten-title">测试</span>
						<span class="notice-conten-time">2025-06-10 00:00:00</span>
					</div>
					<el-button class="notice-button" type="text" size="mini" style="float: right;">查看详情</el-button>
				</div>
			</div>
			<div class="middle-right">
				<div class="box queryWaybill">
					<div class="box-title">快递查询</div>
					<div class="box-content">
						<el-input size="mini" type="textarea" :rows="5" placeholder="请输入快递单号，每行一条，最多20条"
							v-model="waybillNo" resize="none"></el-input>
						<el-button @click="$commonFunction.toQueryWaybill(waybillNo)" type="primary"
							style="position: relative;margin: 4% 0 0 85%;" size="mini" round>查询</el-button>
					</div>
				</div>
				<div class="box task">
					<div style="display: flex;align-items: flex-start;">
						<div class="box-title">待办任务</div>
						<div @click="$commonFunction.to('/workbench/task')"
							style="color: #409EFF;position: absolute;right: 3%;cursor: pointer;">创建任务</div>
					</div>
					<div class="box-content">
						<div style="margin-top: 10%;text-align: center;">
							还没有任务哦
						</div>
					</div>

				</div>
			</div>
		</div>


		<!--底部-数据展示-->
		<div class="bottom" style="display: none;">
			<el-row :gutter="12">
				<el-col :span="6">
					<el-card class="data-card" shadow="never">
						<div class="title">异常监控</div>
						<div class="content">0</div>
						<div class="foot">
							<div class="foot-data-item">
								<div>0</div>
								<div>全链路</div>
							</div>
							<div class="foot-data-item">
								<div>0</div>
								<div>未揽收</div>
							</div>
							<div class="foot-data-item">
								<div>0</div>
								<div>通缉件</div>
							</div>
						</div>
					</el-card>
				</el-col>
				<el-col :span="6">
					<el-card class="data-card" shadow="never">
						<div class="title">订单量</div>
						<div class="content">0</div>
						<div class="foot">
							<div class="foot-data-item">
								<div>0</div>
								<div>今日订单</div>
							</div>
							<div class="foot-data-item">
								<div>{{briefData.totalOrders}}</div>
								<div>本月订单</div>
							</div>
							<div class="foot-data-item">
								<div>{{briefData.pending}}</div>
								<div>待处理</div>
							</div>
						</div>
					</el-card>
				</el-col>
				<el-col :span="6">
					<el-card class="data-card" shadow="never">
						<div class="title">客户数</div>
						<div class="content">0</div>
						<div class="foot">
							<div class="foot-data-item">
								<div>0</div>
								<div>今日新增</div>
							</div>
							<div class="foot-data-item">
								<div>0</div>
								<div>本月新增</div>
							</div>
						</div>
					</el-card>
				</el-col>
				<el-col :span="6">
					<el-card class="data-card" shadow="never">
						<div class="title">面单余额</div>
						<div class="content">0</div>
						<div class="foot">
							<div class="foot-data-item">
								<div>0.00</div>
								<div>钱包余额</div>
							</div>
							<div class="foot-data-item">
								<div>0</div>
								<div>短信余额</div>
							</div>
						</div>
					</el-card>
				</el-col>
			</el-row>
		</div>
</template>

<script>
	export default {
		data() {
			return {
				bannerList: [],
				briefData: {
					abnormal: 0,
					handled: 0,
					pending: 0,
					totalOrders: 0
				},
				waybillNo: "",
				weatherData: {
					weather: "-",
					temperature_float: "-"
				},
				timeState: "morning"
			};
		},
		created() {
			this.getBanner();
			this.getBriefData();
			this.weather();
			this.ifTimeState();
		},
		mounted() {

		},
		methods: {
			//获取首页简要数据
			getBriefData() {
				this.apiService.post({
						modules: "getBriefData",
						content: {}
					})
					.then((res) => {
						//成功
						if (res.status) {
							this.briefData = res.data;
						}
					})
			},
			//获取首页轮播图
			getBanner() {
				this.apiService.post({
						modules: "banner",
						content: {
							platform: 'EXPRESS_WEB'
						}
					})
					.then((res) => {
						//成功
						if (res.status) {
							this.bannerList = res.data;
						}
					})
			},
			//获取天气
			weather() {
				this.apiService.post({
						modules: "getTimestamp",
						content: {}
					})
					.then((res) => {
						//成功
						if (res.status) {
							this.apiService.post({
									modules: "weather",
									content: {
										"ip": res.ip
									}
								})
								.then((res) => {
									//成功
									if (res.status) {
										this.weatherData = res.data;
									}
								})
						}
					})
			},
			//判断天气
			IsInArray(val, arr) {
				var testStr = ',' + arr.join(",") + ",";
				return testStr.indexOf("," + val + ",") != -1;
			},
			ifTimeState() {
				let date = new Date();
				if (date.getHours() >= 0 && date.getHours() < 6) {
					this.timeState = "lateNight"
				} else if (date.getHours() >= 6 && date.getHours() < 8) {
					this.timeState = 'daybreak'
				} else if (date.getHours() >= 8 && date.getHours() < 10) {
					this.timeState = "morning"
				} else if (date.getHours() >= 10 && date.getHours() < 15) {
					this.timeState = "noon"
				} else if (date.getHours() >= 15 && date.getHours() < 19) {
					this.timeState = "afternoon"
				} else if (date.getHours() >= 19 && date.getHours() < 24) {
					this.timeState = "night"
				} else {
					this.timeState = 'morning'
				}
			}

		},
	};
</script>

<style scoped>
	/**头部-温馨提示**/
	.home-head {
		padding: 0.5em 2%;
		background-color: #fff;
		margin: 2vh 0;
		border-radius: 6px;
		display: flex;
		align-items: center;
		cursor: pointer;
	}

	.home-head .weather-icon {
		padding: 0 1%;
	}



	/**中间**/

	/**中间-左侧**/
	.middle-left {
		position: relative;
		width: 68%;
	}

	/**常用功能导航栏**/
	.middle-left .popular-nav {
		padding: 2vh 2% 3vh 2%;
		background-color: #fff;
		border-radius: 6px;

	}

	.popular-nav-title {
		font: 1.4em sans-serif;
		margin-bottom: 2.4vh;
		text-align: left;
	}

	.middle-left .popular-nav .item-list {
		display: flex;
		align-items: center;
	}

	.middle-left .popular-nav .item-list .item {
		text-align: center;
		cursor: pointer;
		margin: 0 5%;
	}

	.middle-left .popular-nav .item-list .item .item-icon {
		border-radius: 12px;
		padding: 10%;
		display: inline-grid;
	}

	.middle-left .popular-nav .item-list .item .item-title {
		font-size: 1em;
		margin-top: 0.7em;
		color: #000;
		line-height: 1em;
	}

	/**轮播图**/
	.middle-left .swiper {
		padding: 1%;
		background-color: #fff;
		margin: 2vh 0;
		border-radius: 0.6em;
	}

	/* .middle-left .swiper > *{
		border-radius: 0.6em;
	} */
	/**公告栏**/
	.middle-left .notice {
		padding: 0.6em;
		background-color: #fff;
		border-radius: 6px;
		display: flex;
		align-items: center;
		text-align: left;
	}

	.middle-left .notice .notice-icon {
		padding: 0 1%;
		display: inline-flex;
	}

	.middle-left .notice .notice-conten {
		width: 88%;
		font-family: sans-serif;
	}

	.middle-left .notice .notice-conten .notice-conten-time {
		margin-left: 4%;
		color: #9a9a9a;
	}


	/**中间-右侧**/
	.middle-right {
		width: 34%;
		margin-left: 1%;
	}

	.middle-right .box {
		background-color: #fff;
		padding: 2.5%;
		border-radius: 4px;
	}

	.middle-right .box:not(:first-child) {
		margin-top: 1vh;
	}

	.middle-right .box .box-title {
		font-size: 1em;
		text-align: left;
		font-family: sans-serif;
		color: #2f2f2f;
		font-weight: 500;
		margin-bottom: 0.4rem;
	}

	/**查询运单**/
	/* .middle-right .queryWaybill{
		min-height: 26vh;
	} */
	.middle-right .box /deep/ .el-textarea__inner {
		color: #606266;
		background-color: #f6f8fa;
		border: none;
	}

	/**待办任务**/
	.middle-right .task {
		padding-top: 2.5%;
		padding-bottom: 9%;
	}




	/**底部-数据展示**/
	.bottom {
		margin-top: 1.4vh;
	}

	.bottom .data-card {
		cursor: default;
		font-family: sans-serif;
		padding-bottom: 1em;
		border: none !important;
		box-shadow: 0 0 23px 0 rgba(109, 140, 209, .24);
	}

	.bottom .data-card .title {
		/* margin: 0.5rem; */
		margin: 0.5rem 0;
		font-size: 1rem;
		font-weight: 500;
		text-align: center;
	}

	.bottom .data-card .content {
		margin-top: 2%;
		/* margin-left: 40%; */
		text-align: center;
		font-size: 1.6rem;
		font-weight: 300;
	}

	.bottom .data-card .foot {
		cursor: pointer;
		display: flex;
		align-items: center;
		justify-content: center;
		font-weight: 400;
	}

	.bottom .data-card .foot-data-item {
		text-align: center;
		margin: 2% 5%;
	}
</style>